<template>
  <div class="filter-bar py-xl flex justify-between flex-wrap align-start page-pad">
    <!-- :class="[$device === 'mobile' ? 'px-m' : 'px-3xl']" -->
    <div class="flex align-start flex-row flex-wrap">
      <div class="flex align-center">

        <label :class="['text-gray-8 font-bd',locale=='HE' ? 'ml-xs':'mr-xs']">
          {{localize('show')}}:
        </label>
        
        <toggle-switch
          v-model="localTypeFilter"
          :locale = "locale"
          :state-ref="typeFilter"
          :switch-list="sortedTypeFilterList"
        ></toggle-switch>
      </div>

      <div :class="[$device === 'mobile' ? 'mt-s' : 'mx-s']">
        <form-field
          :class="[]"
          field-type="select"
          side-label
          :locale = "locale"
          :select-options="fromFilterList"
          v-model="fromFilter"
          multi
          wide
          rounded
        ></form-field>
      </div>
    </div>

    <div
      class="date-pickers flex-child flex f48 align-center justify-end ml-2xl"
    >
      <label :class="['flex-none font-bd text-gray-8',locale=='HE' ? 'ml-xs':'mr-xs']" for=""
        >{{localize('date_range')}}:</label
      >
      <form-field
        :class="['flex-none']"
        field-type="date"
        v-model="filters.fromDate"
        rounded
        icon="calendar-alt"
        :locale = "locale"
        :pikaday-more-options="{
          minDate: new Date('1970-01-01')
        }"
        side-label
      ></form-field>

      <form-field
        class="flex-none mx-s"
        field-type="date"
        v-model="filters.toDate"
        rounded
        icon="calendar-alt"
        :locale = "locale"
        side-label
        :pikaday-more-options="{
          minDate: filters.fromDate
        }"
        pikaday-refresh-date
      ></form-field>
    </div>

    <div :class="['free-search-wrap flex ml-l',locale=='HE' ? 'rtl':'']">
      <div class="flex flex-column flex-child">
        
        <form-field
          class="mb-0 flex-child stretch"
          v-bind:label="localize('search_patiant_number_order_number')"
          label-is-placeholder
          v-model="filters.searchText"
          rounded></form-field>
        <i class="fal fa-search"></i>

        <!-- <form-field
          class="flex-child mt-s ml-xs mb-0"
          field-type="checkbox"
          label="Include complete orders"
          v-model="filters.showCompleteOrders"
          external-label
        ></form-field> -->
      </div>
      <!-- <button class="btn btn-primary rounded ml-s flex-none">
        <i class="fal fa-search"></i>
      </button> -->
    </div>
    <transition name="fast-fade" appear>
      <button v-if="filters.searchText || filters.fromDate || filters.toDate"
        @click="clear" 
        :class="['clear-filters-btn btn btn-primary flex-none rounded',locale=='HE' ? 'rtl':'']"
        >
        <i class="fal fa-times mx-xs"></i>
        <span>{{localize('clear_filters')}}</span>
      </button>
    </transition>
  </div>
</template>




<script>
import ToggleSwitch from "@/components/ToggleSwitch.vue";

import { mapState, mapGetters, mapActions } from "vuex";
export default {
  data() {
    /* 
      vm.fromFilterList[0].label = vm.localize('past_week');
      vm.fromFilterList[1].label = vm.localize('past_month');
      vm.fromFilterList[2].label = vm.localize('last3month');
      vm.fromFilterList[3].label = vm.localize('a_full_year');      
      vm.fromFilterList[4].label = vm.localize('All');                
     */
    return {
      console,
      localTypeFilter: 1,
      fromFilter: 3,
      fromFilterList: [
        {
          label: "past_week",
          value: 1
        },
        {
          label: "past_month",
          value: 2
        },
        {
          label: "last3month",
          value: 3
        },
        {
          label: "a_full_year",
          value: 4
        },
        {
          label: "All",
          value: 5
        }
      ],
      filters: {
        showCompleteOrders: false,
        searchText: "",
        fromDate: null,
        toDate: null
      }
    };
  },
  mounted() 
  {
    var vm=this;
/*     setTimeout(() => {
      vm.fromFilterList[0].label = vm.localize('past_week');
      vm.fromFilterList[1].label = vm.localize('past_month');
      vm.fromFilterList[2].label = vm.localize('last3month');
      vm.fromFilterList[3].label = vm.localize('a_full_year');      
      vm.fromFilterList[4].label = vm.localize('All');            
    }, 500);
 */
    this.updateTimeRangeFilter(parseInt(this.fromFilter));
    if (this.typeFilter !== this.localTypeFilter) 
    {
      this.localTypeFilter = this.typeFilter;
    }
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        console.log("update filters >> ", this.filters);
        this.updateFilters(this.filters);
      }
    },
    fromFilter() {
      this.updateTimeRangeFilter(parseInt(this.fromFilter));
    },
    typeFilter() {
      if (this.typeFilter !== this.localTypeFilter) {
        this.localTypeFilter = this.typeFilter;
      }
    },
    localTypeFilter() {
      this.updateTypeFilter(parseInt(this.localTypeFilter));
    }
  },
  methods: {
    ...mapActions([
      "updateFilters",
      "updateTimeRangeFilter",
      "updateStatusFilter",
      "updateTypeFilter"
    ]),
    clear() {
      this.filters = {
        searchText: "",
        fromDate: null,
        toDate: null
      };

      // this.updateFilters(this.filters);
    }
  },
  components: {
    // StatusBall,
    ToggleSwitch
  },
  computed: {
    ...mapState(["typeFilter", "$device","locale"]),
    ...mapGetters(["isDoctor", "fullName", "minDate"]),
    sortedTypeFilterList() {
      let arr = [
        { label: this.localize('active').toUpperCase(), value: 1 },
        { label: this.localize('archive').toUpperCase(), value: 3 }
      ];
      if (this.isDoctor) {
        arr.push({ label: this.localize('drafts'), value: 2 });
      }
      return _.sortBy(arr, "value");
    }
  }
};
</script>

<style lang="css">
  .toggle-switch,
  .filter-bar input,
  .filter-bar select{
    border:solid 1px #ccc !important;
    background-color: #fbfbfb;
  }
</style>

<style lang="stylus" scoped>
.filter-bar
  background-color #f8f8f8
  position relative
  //border-bottom 1px solid rgba(gray_4, 0.5)
  +below(600px)
    label
      display block
      width 100%
      marg('m', bottom)
  *
    font-size 13px
  +between(901px, 1460px)
    & > :first-child
      //width 100%
    & > :nth-child(2)
      justify-content flex-start
      align-items flex-end
      marg(0, left)
    & > :nth-child(2)
      padding 0px 0px 0px 20px
      //pad('l', top)
    & > :nth-child(3)
      padding 0px
      //pad('l', top)
  +below(900px)
    flex-direction column
    & > *:not(button)
      flex 0 0 100%
      width 100%
      marg(0, x)
      pad('xl', bottom)
      justify-content flex-start !important
.clear-filters-btn
  &.rtl
    right initial
    left 5rem !important
    transform translate(0%, -100%)
  i
    font-size 11px
  background red
  position absolute
  top 100%
  right 0
  padding 0 0.8rem !important
  line-height 1.7rem
  transform translate(-50%, -100%)
  opacity 0.7
  width auto
  &:hover
    background red
    opacity 1
.free-search-wrap
  flex 0 0 25%
  & > div
    position relative
    i
      position absolute
      top 50%
      right 16px
      transform translateY(-50%)
      opacity 0.5
  &.rtl
    i
      right initial
      left 16px
  +below(1100px)
    flex 0 0 100%
    justify-content flex-end
    marg('xl', bottom)

  .btn
    height 44px
    padding 0 15px
</style>
